<template>
  <div class="status-picker-page-template">
    <p class="title">
        What describes you best ?
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "StatusPickerPage"
};
</script>

<style lang="scss" scoped>
.status-picker-page-template {
  height: 100%;
  .title {
    font-size: 3vh;
  }
}
</style>